import { useState, type FormEvent } from "react";
import { Link, Navigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/app/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function LoginPage() {
  const { session, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!loading && session) return <Navigate to="/" replace />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
    if (error) {
      setError(error.message.toLowerCase().includes("rate") ? "Trop de tentatives. Réessaie dans quelques minutes."
        : /fetch|network/i.test(error.message) ? "Connexion au serveur impossible. Vérifie ta connexion internet."
        : "Email ou mot de passe incorrect.");
    }
    setBusy(false);
  }


  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="glass-strong w-full max-w-sm rounded-3xl p-8">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-2xl text-lg font-black text-white" style={{ background: "var(--gradient-primary)" }}>IC</div>
          <div className="font-heading text-2xl font-extrabold tracking-tight">IRONCLIC</div>
          <div className="text-sm text-muted-foreground">Espace de gestion</div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
          <Button type="submit" className="w-full" disabled={busy}>Se connecter</Button>
        </form>
        <p className="mt-4 text-center text-sm"><Link to="/mot-de-passe-oublie" className="text-muted-foreground hover:text-foreground">Mot de passe oublié ?</Link></p>
        <p className="mt-6 text-center text-xs text-muted-foreground">Accès réservé. Les comptes sont créés par un administrateur.</p>
      </div>
    </div>
  );
}
